export default function getDistance3D(
  { x: x1, y: y1, z: z1 },
  { x: x2, y: y2, z: z2 }
) {
  return Math.sqrt(
    Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2) + Math.pow(z2 - z1, 2)
  );
}
